import { render } from "./CompanySheets.vue?vue&type=template&id=0d795b19&ts=true"
import script from "./CompanySheets.vue?vue&type=script&lang=ts"
export * from "./CompanySheets.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__